'use strict';
angular.module('themeQuickPreviewModule', ['themeDetailModule']).controller('themeQuickPreviewCtrl', [
    '$scope',
    '$q',
    '$state',
    '$stateParams',
    '$sce',
    '$filter',
    'resCtrModalService',
    'globleParamsSet',
    'initComDataService',
    'trsHttpService',
    'resourceCenterService',
    'trsspliceString',
    '$interval',
    '$compile',
    '$timeout',
    'storageListenerService',
    function(
        $scope,
        $q,
        $state,
        $stateParams,
        $sce,
        $filter,
        resCtrModalService,
        globleParamsSet,
        initComDataService,
        trsHttpService,
        resourceCenterService,
        trsspliceString,
        $interval,
        $compile,
        $timeout,
        storageListenerService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化页面状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize,
            };
            $scope.data = {
                casDataArea: [], //  地区的级联数组
                items: [], //  列表数据
                pic: [], //  微博的图片数据
                previewItems: [], //  数字报版面数据
                headers: [], //  列表头部
                selectedArray: [], //  复选框所选数据
                operFlags: [], //  取签见撤重
                suggestResult: '', //  搜索匹配结果
                suggestContentList: [], //  搜索匹配的内容列表
                rebuildData: {}, //  传递给右侧详情的信息
                // 发布渠道所选数据
                selectedChannel: {}
            };
            $scope.status = {
                channelType: '', //  栏目类型
                screenWrapSelected: false, //  是否显示更多筛选
                singleGraph: false, //  是否为单图模式
                hasphoto: false, //  是否显示图集
                showRightDetail: true, //  是否显示右侧详情
                curSelected: '', //  当前选中的详情ID
            };
            $scope.basicParams = {
                channelName: 'jtcpg',
                typeName: 'jt_lyzh',
                nodeId: $stateParams.theme,
            };
            $scope.params = {
                //  列表参数
                typeid: 'zyzx',
                serviceid: 'jtcpg',
                modelId: 'findFromNavigation',
                fcode: '',
                pageSize: $scope.page.PAGESIZE,
                pageNum: $scope.page.CURRPAGE,
                keyword: {
                    theme: $stateParams.theme,
                    searchType: '0', // 查询类型
                    keywords: '', // 关键词
                    time: '', // 时间范围
                    area: '', // 地域
                    zyzxfield: '', // 主题
                    isOriginal: '', // 是否原创
                    isHead: '', // 是否头版
                    isRead: '', // 是否10w+
                    menuscriptType: '', // 稿件类型
                },
            };
            // 
            $scope.allChannels = [];
            quickPreviewFix();
        }

        /**
         * [quickPreviewFix 快速预览修正]
         *
         * @return  {[type]}  [return description]
         */
        function quickPreviewFix() {
            if ($state.params.fcode === 'wb') {
                var routerName = $state.current.name.replace(/quickpreview/, 'resource');
                $state.go(routerName, $state.params, { reload: routerName });
            }
        }

        /**
         * [initData 初始化页面数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            if ($scope.basicParams.nodeId) {
                listenStorage();
                getChannel().then(initDropDown).then(function() {
                    if (angular.isDefined($scope.$root.filterDataBack)) {
                        // 判断是否有传递的数据
                        $scope.page = $scope.$root.filterDataBack.page;
                        $scope.data.fromdate = $scope.$root.filterDataBack.fromdate;
                        $scope.data.untildate = $scope.$root.filterDataBack.untildate;
                        $scope.params.keyword = $scope.$root.filterDataBack.paramsKeyword;
                        $scope.params.pageNum = $scope.page.CURRPAGE;
                        $scope.params.pageSize = $scope.page.PAGESIZE;
                        $scope.docType = $scope.$root.filterDataBack.docType; // 当前稿件类型
                        $scope.themeType = $scope.$root.filterDataBack.themeType; // 当前主题
                        $scope.keyType = $scope.$root.filterDataBack.keyType; // 当前检索信息
                        // 默认展开更多筛选项
                        if (
                            $scope.params.keyword.isHead == '1' ||
                            $scope.docType.curValue.value != '' ||
                            $scope.themeType.curValue.id != '' ||
                            $scope.params.keyword.isOriginal == '1' ||
                            $scope.params.keyword.isRead == '1' ||
                            $scope.$root.filterDataBack.area != undefined
                        ) {
                            $scope.status.screenShow = true;
                        }
                        // 默认展开检索信息
                        if ($scope.params.keyword.keywords != '' || $scope.params.keyword.searchType != 0) {
                            $scope.status.searchShow = true;
                        }
                        if ($scope.$root.filterDataBack.area) {
                            $scope.data.casDataArea.push($scope.$root.filterDataBack.area[0]);
                        }
                        if ($scope.$root.filterDataBack.listData) {
                            // 是否图集稿，是则直接传递图集列表数据
                            $scope.status.hasphoto = true;
                            $scope.data.items = $scope.$root.filterDataBack.listData;
                            $scope.status.singleGraph = $scope.$root.filterDataBack.singleGraph; // 是否单图
                            storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourceDetail');
                            if ($scope.data.items.length > 0) {
                                showDetail($scope.data.items[0]);
                            }
                            getFilterDataBack();
                        } else {
                            requestData();
                        }
                    } else {
                        requestData();
                    }
                    $scope.$on('$destroy', function() {
                        // 销毁对象
                        delete $scope.$root.filterDataBack;
                    });
                });
            }
        }

        /**
         * 获取渠道
         * @return  {[type]} [return description]
         */
        function getChannel() {
            const defer = $q.defer();
            const params = {
                typeid: 'zyzx',
                modelid: 'getProductRoot',
                serviceid: 'navigation',
                excludeId: 'navigation_004006;navigation_004005;navigation_004004',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then((data) => {
                if (data && angular.isArray(data.content) && data.content.length > 0) {
                    $scope.allChannels = data.content.map((item) => {
                        item.value = item.fcode;
                        return item;
                    });
                    const channel = $scope.allChannels[0].value;
                    $scope.basicParams.nodeId = channel;
                    $scope.status.channelType = channel;
                    $scope.params.fcode = channel;
                    $scope.data.selectedChannel = $scope.allChannels[0];
                }
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [initDropDown description] 下拉框初始化
         * @return {[type]} [description]
         */
        function initDropDown() {
            var defer = $q.defer();
            // 全部稿件
            $scope.docType = {
                data: initComDataService.resourceCenterNewsType(),
                curValue: initComDataService.resourceCenterNewsType()[0],
            };
            // 检索字段
            $scope.keyType = {
                data: initComDataService.searchBigdataType(),
                curValue: initComDataService.searchBigdataType()[0],
            };
            // 所有主题
            var themeParams = {
                serviceid: 'navigation',
                typeid: 'zyzx',
                modelid: 'base',
                parentId: '-1',
                level: '2',
                excludeId: '-1',
                containParent: false,
                channelName: 'jtcpg',
                typeName: 'zyzxfield',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), themeParams, 'post').then(function(themeData) {
                $scope.themeType = {
                    data: [{ dictName: '所有主题', id: '' }].concat(themeData),
                    curValue: { dictName: '所有主题', id: '' },
                };
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [showSelectedArea description] 数据地域信息的级联菜单获取数据
         * @param  {[type]} node [description] 当前节点
         * @return {[type]}      [description]
         */
        $scope.showSelectedArea = function(node) {
            var deffer = $q.defer();
            resourceCenterService.getArea(node).then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        };

        /**
         * [requestData description]test数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var params = angular.copy($scope.params);
            params.keyword = JSON.stringify(params.keyword);
            params.fcode = $scope.data.selectedChannel.value;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.headers = data.summary_info.hybaseField;
                $scope.data.indexName = data.summary_info.indexName;
                if ($scope.status.channelType == 'szb' && data.content.length > 0) {
                    // 数字报：处理版名版次
                    // dealWithBMBC($scope.data.headers);
                }
                $scope.page = data.summary_info;
                if (!$scope.status.hasphoto) {
                    // 普通稿
                    $scope.data.items = data.content;
                    initOperFlag();
                    findReprintCounts();
                } else {
                    // 图集稿
                    data.content = $scope.data.items.concat(data.content);
                    $scope.data.items = data.content;
                }
                storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourceDetail');
                if ($state.params.guid) {
                    showDetail({ ZB_GUID: $state.params.guid });
                } else if ($scope.data.items.length > 0) {
                    showDetail($scope.data.items[0]);
                }
                getFilterDataBack();
            });
        }

        /**
         * [loadMore description] 图集-加载更多
         * @return {[type]} [description]
         */
        $scope.loadMore = function() {
            $scope.params.pageNum++;
            requestData();
        };

        /**
         * [findReprintCounts description] 获取转载量
         * @return {[type]} [description]
         */
        function findReprintCounts() {
            var tags = trsspliceString.spliceString($scope.data.items, 'MD5TAG', ',');
            if (tags) {
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'jtcpg',
                    modelId: 'findReprintCounts',
                    tags: tags,
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    for (var i = 0; i < $scope.data.items.length; i++) {
                        $scope.data.items[i].REPRINTS_COUNT = data.content[0][$scope.data.items[i].MD5TAG];
                    }
                });
            }
        }

        /**
         * [pageChanged description] 分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            delete $state.params.guid; // 分页跳转时不需要从路由上获取数据
            requestData();
        };

        /**
         * [initOperFlag 初始化取签见撤重]
         *
         * @return  {[type]}  [return description]
         */
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.items, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds,
                };
                params = angular.extend(params, $scope.basicParams);
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
        }

        /**
          * [viewBigDataInfo 取签见撤重 点击弹出]
          *
          * @param   {[type]}  ChnlDocId   [ChnlDocId description]
          * @param   {[type]}  showRepeat  [showRepeat description]
          * @param   {[type]}  showClick   [showClick description]
          * @param   {[type]}  $event      [$event description]
          *
          * @return  {[type]}              [return description]
          */
        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick, $event) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
            event.stopPropagation();
        };

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description]
         * @param  {[type]} flagIndex [description]
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].GUID) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        /**
         * [isShowSearch description]显示隐藏检索条件
         * @return {Boolean} [description]
         */
        $scope.isShowSearch = function() {
            $scope.status.searchShow = !$scope.status.searchShow;
            // 隐藏清空？
            //
        };

        /**
         * [getFilterTimeVal description]检索下拉框回调
         * @return {[type]} [description]
         */
        $scope.getFilterVal = function() {
            console.log($scope.data.robotSelected);
        };

        /**
         * [fullTextSearch 全文检索]
         *
         * @param   {[type]}  ev  [ev 按下回车也能提交]
         *
         * @return  {[type]}      [return description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = '1';
                delete $state.params.guid; // 全文检索时不需要从路由上获取数据
                requestData();
            }
        };

        /**
         * [showScreen description] 显示隐藏更多筛选
         * @return {[type]} [description]
         */
        $scope.showScreen = function() {
            $scope.status.screenShow = !$scope.status.screenShow;
        };

        /**
         * [searchWithKeyword description] 根据条件筛选稿件
         * @param  {[type]} key   [description] 筛选类型
         * @param  {[type]} value [description] 筛选内容
         * @return {[type]}       [description]
         */
        $scope.searchWithKeyword = function(key, value) {
            if (key == 'time') {
                value = $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString()
                    ? $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() +
                      ',' +
                      $filter('date')($scope.data.untildate, 'yyyy/MM/dd').toString()
                    : '';
            } else if (key == 'area') {
                value = value[0][value.length - 1].id;
            }
            if (key) {
                $scope.params.keyword[key] = value;
            }
            if (key === 'menuscriptType'){
                $scope.status.hasphoto = (value === '2');
            }
            $scope.params.keyword.searchType = $scope.keyType.curValue.value;
            $scope.params.pageNum = $scope.page.CURRPAGE = 1;
            $scope.data.items = [];
            delete $state.params.guid; // 不需要从路由上获取数据
            requestData();
        };

        /**
         * [singleGraphMode description] 是否为单图模式
         * @return {[type]} [description]
         */
        $scope.singleGraphMode = function() {
            $scope.status.singleGraph = !$scope.status.singleGraph;
            delete $state.params.guid; // 不需要从路由上获取数据
            requestData();
        };

        /**
         * [getFilterDataBack description]获取跳转回普通视图存储信息
         * @return {[type]} [description]
         */
        function getFilterDataBack() {
            $scope.$root.filterDataBack = {
                page: $scope.page, // 分页
                fromdate: $scope.data.fromdate, // 开始时间
                untildate: $scope.data.untildate, // 结束时间
                paramsKeyword: $scope.params.keyword, // 其他条件
                area: $scope.data.area, // 地域信息
                docType: $scope.docType, // 当前稿件类型
                themeType: $scope.themeType, // 当前主题
                keyType: $scope.keyType, // 当前检索信息
            };
            if ($scope.status.hasphoto) {
                // 是否图集稿，是则直接传递图集列表数据
                $scope.$root.filterDataBack.listData = $scope.data.items;
                $scope.$root.filterDataBack.singleGraph = $scope.status.singleGraph; // 是否单图
            }
        }

        /**
         * [showDetail description]展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.showDetail = function(item) {
            showDetail(item);
        };

        /**
         * [showDetail description] 展示详情
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function showDetail(item) {
            $scope.status.showRightDetail = false;
            $state.params.guid = item.ZB_GUID;
            $state.go($state.current.name, $state.params, { reload: false });
            $scope.data.rebuildData = {
                guid: item.ZB_GUID,
            };
            $timeout(function() {
                $scope.status.curSelected = item.ZB_GUID;
                $scope.status.showRightDetail = true;
            });
        }

        /**
         * [plainView description] 普通视图
         * @return {[type]} [description]
         */
        $scope.plainView = function() {
            $state.go('front.resourcectrl.theme.resource', $stateParams);
        };
    },
]);
